import { render, staticRenderFns } from "./CalendarWidgetSettings.vue?vue&type=template&id=15ff7592"
import script from "./CalendarWidgetSettings.vue?vue&type=script&lang=js"
export * from "./CalendarWidgetSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports